/* eslint-disable */
import 'unfetch/polyfill'
import { AppRegistry } from 'react-native'
import App from './App'
import platform from './utils/platform'

if (platform.info().os == 'iOS' || platform.info().os == 'Android') {
  window.location.replace(platform.info().os == 'iOS'
    ? 'https://apps.apple.com/app/id1419671135'
    : 'https://play.google.com/store/apps/details?id=com.duoreading')
} else {
  AppRegistry.registerComponent('App', () => App)
  AppRegistry.runApplication('App', {
    rootTag: document.getElementById('root')
  })
}

